import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//Components
import Form from './Form/Form.constants';
//Redux
import { useSelector, useDispatch } from 'react-redux';
import { updateHousekey, getAllHousekeys } from '../../redux/housekeys/thunks';
import useScan from '../../hooks/useScan';

const EditHousekey = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();
  useEffect(() => {
    setDestination('act-e-hou', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const location = useLocation();
  const idEdit: number = parseInt(location?.pathname.split('/').pop() || '');
  useEffect(() => {
    const filter = `&id=${idEdit}`;
    dispatch(getAllHousekeys({ filter, pagination: {} }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEdit]);

  // housekey a edit
  const { keys } = useSelector((state: any) => state.housekeys.housekeys);
  const housekeyedit = keys?.filter((item: any) => item.id === idEdit);

  const submitEditHousekey = (values: any) => {
    dispatch(updateHousekey({ values }))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/housekeys', { replace: true });
        }
      });
  };
  return (
    <>
      {housekeyedit && housekeyedit[0] && (
        <Form
          submitHousekey={submitEditHousekey}
          initialValues={housekeyedit[0]}
          isEdit={true}
          actionText='GUARDAR'
        />
      )}
    </>
  );
};

export default EditHousekey;
